export const webEmbedTab = {
  scope: {
    title: "ما الذي يُبحَث عنه في موقعك؟",
    only: "فقط",
    thisListing: "هذا الإعلان",
    hint: "يُوصى به إذا لصقت الكود في صفحة مكان الإقامة هذا. عطّله ليعرض البحث جميع أماكن إقامتك.",
  },
  where: {
    title: "أين تريد أن تظهر أماكن الإقامة؟",
    hint: "يظهر شريط البحث بالشكل نفسه في الحالات الثلاث. ما يتغيّر هو ما يحدث عندما ينقر الزائر على «بحث».",
    ariaLabel: "أين يظهر التوفّر",
    ownFields: {
      name: "لديّ بالفعل شريط بحث خاص بي",
      hint: "لن نضيف شريطنا: استخدم حقولك الخاصة ومرّر لنا البحث",
    },
  },
  modes: {
    overlay: {
      name: "يطفو فوق موقعك",
      tag: "موصى به",
      desc: "تُفتَح القائمة في نافذة فوق صفحتك، وتُغلَق بعلامة X. لا يتحرّك موقعك: يعود الزائر تمامًا إلى حيث كان.",
    },
    inline: {
      name: "داخل صفحتك",
      desc: "تظهر القائمة في موقعك نفسه كقسم إضافي: يمكن تمريرها مع بقية المحتوى ولا شيء يحتاج إلى إغلاق. أنت تختار في أيّ موضع من الصفحة تظهر.",
    },
    tab: {
      name: "في علامة تبويب جديدة",
      desc: "يبقى الشريط في موقعك، وعند البحث يستمرّ الحجز في علامة تبويب أخرى. إنه الخيار الأبسط، لكنّ الزائر ينتقل بالحجز إلى مكان آخر.",
    },
  },
  modeNote: {
    overlay: "يشغل شريط البحث ارتفاعًا ثابتًا لا يتغيّر: تجري القائمة وكامل عملية الحجز في النافذة الطافية، بتمريرها الخاص.",
    inline: "هنا الشيء الوحيد الذي يتوسّع هو قسم القائمة، وهو تمامًا ما طلبت أن يتوسّع. يظل شريط البحث بالحجم نفسه ويُفتَح التقويم فوقه دون إزاحة أي شيء.",
    tab: "يُضمَّن الشريط فقط. كل شيء آخر يجري في محرّك الحجوزات، في علامة تبويب منفصلة.",
  },
  webs: {
    bahia: "موقع بصورة رئيسية",
    cala: "موقع بسيط",
  },
  fondos: {
    white: "أبيض (افتراضي)",
    transparent: "شفاف · يتبنّى خلفية موقعك",
  },
  appearance: {
    title: "المظهر",
    buttonColor: "لون الزر",
    background: "خلفية شريط البحث",
    language: "اللغة",
  },
  preview: {
    title: "هكذا يبدو على موقع",
    hint: "موقع نموذجي مع شريط البحث الخاص بك جاهزًا. إنها الأداة الحقيقية: اختر التواريخ وانقر على «بحث» لترى كيف تعمل.",
    openFull: "فتح بالحجم الكامل",
    testIn: "التجربة على",
    testInAriaLabel: "موقع نموذجي",
    missingUuid: "مُعرِّف الحساب مفقود لإنشاء الأداة.",
    fakeUrl: "موقعك.com",
    iframeTitle: "معاينة الأداة على موقع نموذجي",
  },
  guide: {
    title: "كيف تضيفه إلى موقعك",
    hint: "يصلح لأي صفحة: HTML وWordPress (كتلة «HTML مخصّص») وWix وSquarespace وShopify… لا حاجة إلى تثبيت أي شيء.",
    warn: "<b>إذا كان موقعك على Wix أو Squarespace أو Shopify</b>، فأمران: في <b>المحرّر</b> تظهر كتلة الكود فارغة دائمًا —لا تعمل إلا في «المعاينة» أو بعد النشر—، ولأن هذه المنصّات تحصر شريط البحث داخل إطار خاص بها، <b>يحدث كل شيء داخل ذلك الإطار</b>: التقويم وقائمة أماكن الإقامة. لذا <b>مدّده إلى نحو 900 بكسل ارتفاعًا</b> في المحرّر؛ إذا بقي قصيرًا، يظهر التقويم مقطوعًا. نتكفّل نحن بالباقي: لا تغيّر الكود.",
    missingUuid: "مُعرِّف الحساب مفقود لإنشاء الكود.",
    copy: "نسخ",
    copied: "تم النسخ",
    saveReload: "احفظ موقعك وأعد تحميله",
  },
  steps: {
    script: {
      title: "الصق هذا حيث تريد أن يظهر شريط البحث",
      titleOwn: "الصق هذا مرة واحدة، في أي موضع من الصفحة",
      hint: "في المكان المحدّد الذي تريد فيه شريط التواريخ: الواجهة الرئيسية، أو شريط أسفل القائمة، أو شريط جانبي…",
      hintOwn: "لا يرسم شيئًا بمفرده: يجهّز الحجز لنموذجك الخاص.",
      after: "يشغل الشريط ارتفاعًا ثابتًا ولا يتغيّر حجمه، لذا لن يخلّ بترتيب صفحتك.",
    },
    target: {
      title: "الصق هذا الموضع حيث تريد أن تظهر القائمة",
      hint: "عادةً قسم خاص أسفل الواجهة الرئيسية، مع عنوانك فوقه («التوفّر»، «منازلنا»…).",
      after: "إلى أن يبحث أحدهم، لا يشغل هذا الموضع أي مساحة. إذا لم تضعه، تظهر القائمة أسفل شريط البحث مباشرة.",
    },
    api: {
      title: "اربط حقولك بالبحث",
      hint: "تحتفظ بتصميمك الخاص، لكن يمكن أن يكون التقويم تقويمنا: الذي يعرض سعر كل ليلة، والحد الأدنى للإقامة، والأيام المحجوزة.",
      after: "إذا كنت تفضّل حقول تواريخك الخاصة، فهذا ممكن أيضًا: مرّر لنا التواريخ بصيغة YYYY-MM-DD مباشرةً إلى WACheckin.search().",
    },
  },
  toasts: {
    manualCopySummary: "نسخ يدوي",
    manualCopyDetail: "لم يسمح متصفّحك بالنسخ تلقائيًا. الكود محدَّد بالفعل.",
  },
};
